import {
	ReactElement,
	useMemo
} from "react";
import {
	RecurrenceRangeFormModel
} from "../common";
import { TimeZone } from "client/DateAndTime/timezones";
import {
	DatePicker,
	FormItem,
	Select,
	SelectItem,
	ValidationError
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { AppointmentRecurrenceRangeKind } from "client/Api/Calendar/calendar";
import { IValueInputAttachable } from "client/Forms/attachable";

export type RepeatEndDateSelectorProps = {
	attachable: IValueInputAttachable<RecurrenceRangeFormModel>;
	timezone: TimeZone;
};

export const RepeatEndDateSelector = (props: RepeatEndDateSelectorProps): ReactElement => {
	const {
		attachable,
		timezone
	} = props;

	const options = useMemo(
		(): readonly SelectItem<AppointmentRecurrenceRangeKind>[] => {
			return [
				{
					text: localize("_OnDate"),
					value: AppointmentRecurrenceRangeKind.EndDate
				},
				{
					text: localize("_Never"),
					value: AppointmentRecurrenceRangeKind.NoEnd
				}

			];
		},
		[]
	);

	return (
		<>
			<FormItem
				label={localize("_EndRepeat")}
			>
				<Select
					{...attachable.for("kind").attachToSelect()}
					menuTitle={localize("_Repeat")}
					options={options}
				/>
				<ValidationError {...attachable.for("kind").attachToValidationError()} />
			</FormItem>
			{attachable.when(
				x => x.kind === AppointmentRecurrenceRangeKind.EndDate,
				(handlerWithEndDate) => (
					<FormItem
						label={localize("_EndRepeatDate")}
						isRequired
					>
						<DatePicker
							{...handlerWithEndDate.for("endDate").attachToDatePicker()}
							timezone={timezone}
							mode="date"
						/>
						<ValidationError {...handlerWithEndDate.for("endDate").attachToValidationError()} />
					</FormItem>
				)
			)}
		</>
	);
};
RepeatEndDateSelector.displayName="RepeatEndDateSelector";
